module.exports = __webpack_public_path__ + "img/171824.70fc92fe.png";